import { schema as citationSchema } from "@jsr/bids__schema/citation";
import { compile } from "./json.js";
import { parse } from "@jsr/std__yaml";
const citationFilename = 'CITATION.cff';
export async function citationValidate(schema, dsContext) {
  const citationFile = dsContext.tree.get(citationFilename);
  if (!citationFile || 'directories' in citationFile) return;
  let citation = {};
  try {
    citation = parse(await citationFile.text());
  } catch (error) {
    dsContext.issues.add({
      code: 'FILE_READ',
      issueMessage: `Error from attempted read of file:\n${error}`,
      location: citationFilename
    });
    return;
  }
  const validate = compile(citationSchema);
  if (!validate(citation)) {
    for (const err of validate.errors){
      dsContext.issues.add({
        code: 'CITATION_CFF_VALIDATION_ERROR',
        subCode: err['instancePath'],
        issueMessage: err['message'],
        location: citationFilename
      });
    }
  }
}
//# sourceMappingURL=citation.js.map